import state from './moduleCorrespondenciaState'
import mutations from './moduleCorrespondenciaMutations'
import actions from './moduleCorrespondenciaActions'
import getters from './moduleCorrespondenciaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
